import './App.css'
import { Redirect, Route, Switch } from 'react-router-dom'
import {
  CREATE_USER_PATH,
  EDIT_USER_PATH,
  HOME_PATH,
  SIGN_IN_PATH
} from 'routes/constants.routes'
import SignIn from 'pages/SignIn/SignIn'
import PrivateRoute from 'routes/PrivateRoute'
import useAuthStore from 'context/AuthStore/useAuthStore'
import Home from 'pages/Home/Home'
import { useRoutes } from 'hooks'
import NoMatch from 'pages/NoMatch/NoMatch'
import { ProfileRoutes } from 'pages/Profile/Profile'

function App(props) {
  const { authStore } = useAuthStore()
  const { lastVisit } = useRoutes()
  return (
    <Switch>
      <PrivateRoute exact path={HOME_PATH} component={Home} />
      <PrivateRoute
        path={[CREATE_USER_PATH, EDIT_USER_PATH + '/:id']}
        component={ProfileRoutes}
      />
      <Route path={SIGN_IN_PATH} render={props => <SignIn {...props} />} />
      <Route
        path={'/'}
        render={() => (
          <Redirect
            to={
              authStore.isLoggedIn
                ? lastVisit
                  ? lastVisit
                  : HOME_PATH
                : SIGN_IN_PATH
            }
          />
        )}
      />
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  )
}

export default App
